module.exports = __webpack_public_path__ + "img/ica_peln_hover.91c45ca4.png";